//#region src/routes.ts
var e = {
	HOME: "/",
	AUTH: {
		LOGIN: "/auth/login",
		REGISTER: "/auth/register",
		VERIFY_OTP: "/auth/verify-otp",
		FORGOT_PASSWORD: "/auth/forgot-password"
	},
	DASHBOARD: "/",
	SEARCH: {
		ROOT: "/search",
		ASSISTANT: "/search/assistant"
	},
	PROPERTIES: {
		ROOT: "/properties",
		MAP: "/properties/map",
		CREATE: "/properties/create",
		RESUME_DRAFT: "/properties/create/:draftId",
		DETAILS: "/properties/:propertyId",
		PREVIEW: "/properties/:propertyId/preview",
		EDIT_IMAGES: "/properties/:propertyId/edit/images",
		EDIT_AMENITIES: "/properties/:propertyId/edit/amenities",
		EDIT_PRICING: "/properties/:propertyId/edit/pricing",
		EDIT_HOUSE_RULES: "/properties/:propertyId/edit/house-rules",
		EDIT_QUICK_RULES: "/properties/:propertyId/edit/rules",
		EDIT_AUTOMATED_MESSAGES: "/properties/:propertyId/edit/automated-messages",
		EDIT_ASSIGNED_RULES: "/properties/:propertyId/edit/assigned-rules",
		EDIT_NAME: "/properties/:propertyId/edit/name",
		EDIT_FACILITIES: "/properties/:propertyId/edit/facilities",
		CALENDAR_SYNC_FEED_DETAILS: "/properties/:propertyId/calendar-sync/feeds/:feedId",
		MANAGE_LISTINGS: "/properties/:propertyId/listings",
		ADD_UNIT: "/properties/:propertyId/units/new",
		AMENITIES: "/properties/amenities",
		LISTING: "/properties/listing/:id",
		PUBLIC: "/stays/property/:propertyId",
		BOOKING: "/properties/listing/:id/book"
	},
	UNITS: {
		ROOT: "/units",
		EDIT: "/units/:unitId/edit",
		ADD_LISTING: "/units/:unitId/listings/new",
		ADD_ROOMS: "/units/:unitId/rooms/new",
		DETAILS: "/units/:unitId"
	},
	ROOMS: {
		ROOT: "/rooms",
		DETAILS: "/rooms/:roomId"
	},
	LISTINGS: {
		ROOT: "/listings",
		EDIT_IMAGES: "/listings/:listingId/edit/images",
		EDIT_AMENITIES: "/listings/:listingId/edit/amenities",
		EDIT_PRICING: "/listings/:listingId/edit/pricing",
		EDIT_HOUSE_RULES: "/listings/:listingId/edit/house-rules",
		EDIT_QUICK_RULES: "/listings/:listingId/edit/rules",
		EDIT_AUTOMATED_MESSAGES: "/listings/:listingId/edit/automated-messages",
		EDIT_ASSIGNED_RULES: "/listings/:listingId/edit/assigned-rules"
	},
	EXPERIENCES: {
		ROOT: "/experiences",
		CREATE: "/experiences/create",
		DETAILS: "/experiences/:experienceId",
		EDIT: "/experiences/:experienceId/edit",
		SESSIONS: "/experiences/:experienceId/sessions",
		LISTING: "/experiences/:listingId"
	},
	SERVICES: {
		ROOT: "/services",
		CREATE: "/services/create",
		DETAILS: "/services/:serviceId",
		EDIT: "/services/:serviceId/edit",
		SESSIONS: "/services/:serviceId/sessions",
		LISTING: "/services/:listingId"
	},
	PROPERTY_GROUPS: {
		ROOT: "/property-groups",
		CREATE_GROUP: "/property-groups/create",
		DETAILS: "/property-groups/:groupId",
		EDIT: "/property-groups/:groupId/edit"
	},
	BOOKINGS: {
		ROOT: "/bookings",
		DETAILS: "/bookings/:bookingId",
		REQUESTS: "/bookings/requests",
		CALENDAR: "/bookings/calendar",
		RULES: "/bookings/rules",
		CREATE_RULE: "/bookings/rules/create",
		EDIT_RULE: "/bookings/rules/:ruleId/edit",
		RULE_DETAILS: "/bookings/rules/:ruleId"
	},
	FRONT_DESK: {
		ROOT: "/front-desk",
		TODAY: "/front-desk/today"
	},
	PRICING: {
		ROOT: "/pricing",
		RULES: "/pricing/rules",
		CREATE_RULE: "/pricing/rules/create",
		EDIT_RULE: "/pricing/rules/:ruleId/edit",
		RULE_DETAILS: "/pricing/rules/:ruleId",
		RATES: "/pricing/rates",
		RATES_BULK: "/pricing/rates/bulk"
	},
	COUPONS: {
		ROOT: "/finance/coupons",
		CREATE: "/finance/coupons/create",
		DETAILS: "/finance/coupons/:couponId",
		EDIT: "/finance/coupons/:couponId/edit"
	},
	TRAVEL_GUIDES: {
		ROOT: "/travel-guides",
		CREATE: "/travel-guides/create",
		EDIT: "/travel-guides/:guideId/edit"
	},
	FINANCE: {
		ROOT: "/finance",
		EARNINGS: "/finance/earnings",
		WITHDRAWALS: "/finance/withdrawals",
		WITHDRAWAL_DETAILS: "/finance/withdrawals/:id",
		WITHDRAWAL_METHODS: "/finance/withdrawal-methods",
		WITHDRAWAL_METHOD_CREATE: "/finance/withdrawal-methods/create",
		WITHDRAWAL_METHOD_EDIT: "/finance/withdrawal-methods/:id/edit",
		INVOICES: "/finance/invoices",
		PENALTY: "/finance/penalty",
		PENALTY_DETAIL: "/finance/penalty/:id",
		PENALTIES: "/finance/penalties"
	},
	TRIPS: {
		ROOT: "/trips",
		DETAILS: "/trips/:tripId",
		REVIEW: "/trips/:tripId/review"
	},
	PAYMENTS: {
		ROOT: "/payments",
		SUCCESS: "/payments/success",
		FAILED: "/payments/failed",
		NATIVE_RETURN: "/payments/native-return"
	},
	FAVORITES: { ROOT: "/favorites" },
	GUIDES: {
		ROOT: "/guides",
		DESTINATION: "/guides/destinations/:areaId",
		DETAILS: "/guides/:id"
	},
	HOSTS: {
		ROOT: "/hosts",
		PROFILE: "/hosts/:id",
		LISTINGS: "/hosts/:id/listings",
		GUIDES: "/hosts/:id/guides",
		REVIEWS: "/hosts/:id/reviews"
	},
	CHAT: "/chat",
	MESSAGES: {
		ROOT: "/messages",
		CONVERSATION: "/messages/:conversationId",
		MATCH: "/messages/:conversationId?"
	},
	ACTIONS: "/actions",
	NOTIFICATIONS: "/notifications",
	WORKSPACES: {
		ROOT: "/workspaces",
		CREATE: "/workspaces/create",
		INVITE: "/workspaces/invite",
		MEMBERS: "/workspaces/members",
		MEMBER_PERMISSIONS: "/workspaces/members/:userId/permissions",
		ROLES: "/workspaces/roles",
		CREATE_ROLE: "/workspaces/roles/create",
		ROLE_DETAILS: "/workspaces/roles/:roleId",
		EDIT_ROLE: "/workspaces/roles/:roleId/edit",
		SETTINGS: "/workspaces/settings",
		SETTINGS_GENERAL: "/workspaces/settings/general",
		SETTINGS_VERIFICATION: "/workspaces/settings/verification",
		SETTINGS_BILLING: "/workspaces/settings/billing",
		SETTINGS_NOTIFICATIONS: "/workspaces/settings/notifications",
		SETTINGS_INTEGRATIONS: "/workspaces/settings/integrations",
		SETTINGS_OPERATIONS: "/workspaces/settings/operations",
		SETTINGS_DEVELOPER: "/workspaces/settings/developer",
		SETTINGS_DEVELOPER_TERMS: "/workspaces/settings/developer/terms",
		SETTINGS_DEVELOPER_ISSUE_KEY: "/workspaces/settings/developer/keys/new"
	},
	DEVELOPER: {
		ROOT: "/developer",
		KEYS: "/developer/keys",
		KEYS_NEW: "/developer/keys/new",
		WEBHOOKS: "/developer/webhooks",
		WEBHOOKS_REGISTER: "/developer/webhooks/register",
		LOGS: "/developer/logs",
		SANDBOX: "/developer/sandbox",
		TERMS: "/developer/terms"
	},
	INVITES: "/invites",
	INVITE: "/invite/:code",
	ID_NOTICE: "/id-notice/:noticeId",
	VERIFICATION: { CALLBACK: "/verification/callback" },
	CREATOR: {
		ROOT: "/creator",
		LINKS: "/creator/links",
		LINK_NEW: "/creator/links/new",
		LINK_DETAILS: "/creator/links/:linkId",
		EARNINGS: "/creator/earnings",
		WITHDRAWAL_METHODS: "/creator/withdrawal-methods",
		WITHDRAWAL_METHOD_NEW: "/creator/withdrawal-methods/new",
		SOCIAL_LINKS: "/creator/social-links"
	},
	ADMIN: {
		ROOT: "/admin",
		LOGIN: "/admin/login",
		DASHBOARD: "/admin/dashboard",
		INSIGHTS: "/admin/insights",
		SATISFACTION: {
			ROOT: "/admin/satisfaction",
			OVERVIEW: "/admin/satisfaction",
			RESPONSES: "/admin/satisfaction/responses"
		},
		HEALTH: "/admin/health",
		VERIFICATIONS: {
			ROOT: "/admin/verifications",
			DETAILS: "/admin/verifications/:kind/:id"
		},
		AREAS: {
			ROOT: "/admin/areas",
			NEW: "/admin/areas/new",
			DETAILS: "/admin/areas/:id",
			EDIT: "/admin/areas/:id/edit"
		},
		POPULAR_FILTERS: { ROOT: "/admin/popular-filters" },
		MARKETING: {
			ROOT: "/admin/marketing",
			NEW: "/admin/marketing/new",
			DETAILS: "/admin/marketing/:id",
			EDIT: "/admin/marketing/:id/edit"
		},
		NOTIFICATIONS: {
			ROOT: "/admin/notifications",
			TEMPLATES: "/admin/notifications/templates",
			TEMPLATE_EDIT: "/admin/notifications/templates/:id",
			ANALYTICS: "/admin/notifications/analytics"
		},
		FINANCE: { ROOT: "/admin/finance" },
		PAYOUTS: {
			ROOT: "/admin/payouts",
			DETAILS: "/admin/payouts/:id"
		},
		CREATOR_PAYOUTS: { ROOT: "/admin/creator-payouts" },
		COUPONS: {
			ROOT: "/admin/coupons",
			NEW: "/admin/coupons/new",
			DETAILS: "/admin/coupons/:id",
			EDIT: "/admin/coupons/:id/edit"
		},
		PARTNERS: {
			ROOT: "/admin/partners",
			NEW: "/admin/partners/new",
			DETAILS: "/admin/partners/:id",
			EDIT: "/admin/partners/:id/edit",
			LINK_NEW: "/admin/partners/:id/links/new",
			LINK_EDIT: "/admin/partners/:id/links/:linkId/edit",
			LINK_DETAILS: "/admin/partners/:id/links/:linkId",
			APPLICATIONS: "/admin/partner-applications",
			APPLICATION_REVIEW: "/admin/partner-applications/:id"
		},
		COUPON_DEFICITS: { ROOT: "/admin/coupon-deficits" },
		UNIT_CHANGE_DEFICITS: { ROOT: "/admin/unit-change-deficits" },
		RULE_TEMPLATES: {
			ROOT: "/admin/rule-templates",
			NEW: "/admin/rule-templates/new",
			EDIT: "/admin/rule-templates/:domain/:id/edit"
		},
		USERS: {
			ROOT: "/admin/users",
			DETAILS: "/admin/users/:id",
			EDIT: "/admin/users/:id/edit"
		},
		WORKSPACES: {
			ROOT: "/admin/workspaces",
			DETAILS: "/admin/workspaces/:id",
			DECLINE_DEVELOPER_ACCESS: "/admin/workspaces/:id/developer-access/decline",
			REVOKE_DEVELOPER_ACCESS: "/admin/workspaces/:id/developer-access/revoke",
			DEVELOPER_KEY_RATE_LIMIT: "/admin/workspaces/:id/developer-access/keys/:keyId/rate-limit"
		},
		LISTINGS: {
			ROOT: "/admin/listings",
			DETAILS: "/admin/listings/:id",
			EDIT_PRICING: "/admin/listings/:id/edit/pricing",
			EDIT_AMENITIES: "/admin/listings/:id/edit/amenities",
			EDIT_UNIT_DETAILS: "/admin/listings/:id/edit/unit-details"
		},
		LISTING_MODERATION: { ROOT: "/admin/listing-moderation" },
		IMAGE_MODERATION: { ROOT: "/admin/image-moderation" },
		TRAVEL_GUIDES: {
			ROOT: "/admin/travel-guides",
			REVIEW: "/admin/travel-guides/:guideId"
		},
		BOOKINGS: {
			ROOT: "/admin/bookings",
			DETAILS: "/admin/bookings/:id",
			CHANGE_UNIT: "/admin/bookings/:id/change-unit"
		},
		SUPPORT: {
			ROOT: "/admin/support",
			TICKET_DETAILS: "/admin/support/tickets/:id",
			ARTICLES: {
				ROOT: "/admin/support/articles",
				NEW: "/admin/support/articles/new",
				EDIT: "/admin/support/articles/:id/edit"
			},
			CATEGORIES: "/admin/support/categories",
			FAQS: {
				ROOT: "/admin/support/faqs",
				NEW: "/admin/support/faqs/new",
				EDIT: "/admin/support/faqs/:id/edit"
			},
			CALLBACKS: "/admin/support/callbacks"
		},
		AI_CONVERSATIONS: {
			ROOT: "/admin/ai-conversations",
			OVERVIEW: "/admin/ai-conversations",
			CONVERSATIONS: "/admin/ai-conversations/conversations",
			DETAILS: "/admin/ai-conversations/conversations/:id"
		},
		AI_GENERATIONS: { ROOT: "/admin/ai-generations" },
		OPERATIONS: {
			FEEDS: "/admin/operations/feeds",
			FEED_DETAILS: "/admin/operations/feeds/:id",
			DLQ: "/admin/operations/dlq",
			ANNOUNCEMENTS: "/admin/operations/announcements",
			ANNOUNCE: "/admin/operations/announcements/new"
		},
		DEVELOPER: {
			DLQ: "/admin/developer/dlq",
			LAMBDAS: "/admin/developer/lambdas",
			ROUTING_TELEMETRY: "/admin/developer/routing-telemetry",
			PAYMENT_INBOX: "/admin/developer/payment-inbox",
			DIDIT_INBOX: "/admin/developer/didit-inbox",
			AKEDLY_INBOX: "/admin/developer/akedly-inbox",
			PHONE_AUTH: "/admin/developer/phone-auth",
			PRICELABS_INBOX: "/admin/developer/pricelabs-inbox",
			PRICELABS_HEALTH: "/admin/developer/pricelabs-health",
			PLATFORM: "/admin/developer/platform",
			DEVELOPERS: "/admin/developer/developers",
			DEVELOPER_DETAILS: "/admin/developer/developers/:workspaceId",
			PARTNER_DELIVERIES: "/admin/developer/partner-deliveries",
			PARTNER_REQUESTS: "/admin/developer/partner-requests",
			ACCESS_REQUESTS: "/admin/developer/access-requests",
			OUTBOX: "/admin/developer/outbox",
			CRON: "/admin/developer/cron",
			MEDIA_PIPELINE: "/admin/developer/media-pipeline",
			VERSION: "/admin/developer/version",
			LAUNCH_GATES: "/admin/developer/launch-gates",
			API_KEYS: "/admin/developer/api-keys",
			API_KEYS_NEW: "/admin/developer/api-keys/new",
			MCP_KEYS: "/admin/developer/mcp-keys",
			MCP_KEYS_NEW: "/admin/developer/mcp-keys/new",
			SLACK: "/admin/developer/slack",
			SLACK_OPERATOR_NEW: "/admin/developer/slack/operators/new",
			SLACK_CHANNEL_NEW: "/admin/developer/slack/channels/new"
		},
		ADMINS: {
			ROOT: "/admin/admins",
			INVITE: "/admin/admins/invite"
		}
	},
	ACCOUNT: {
		ROOT: "/account",
		GETTING_STARTED: "/account/getting-started",
		DETAILS: "/account/details",
		SECURITY: "/account/security",
		NOTIFICATIONS: "/account/notifications",
		PRIVACY: "/account/privacy",
		LANGUAGE: "/account/language",
		PAYMENT_METHODS: "/account/payment-methods",
		IDENTITY_VERIFICATION: "/account/identity-verification",
		LOGIN: "/account/login",
		HELP: "/account/help",
		COUPONS: "/account/coupons",
		CREATOR_PARTNER: "/account/creator-partner"
	},
	HELP: {
		ROOT: "/help",
		CATEGORY: "/help/categories/:slug",
		ARTICLE: "/help/articles/:slug",
		FAQ: "/help/faq",
		CONTACT: "/help/contact",
		CONTACT_PENDING: "/help/contact/:ticketId",
		CALLBACK: "/help/callback"
	},
	ABOUT: "/about",
	HOST_WITH_US: "/host-with-us",
	LEGAL: {
		TERMS: "/legal/terms",
		PRIVACY: "/legal/privacy"
	}
};
//#endregion
export { e as ROUTES };
